import { render, staticRenderFns } from "./mini-program-message-release-add.vue?vue&type=template&id=38eb7da9&scoped=true"
import script from "./mini-program-message-release-add.vue?vue&type=script&lang=js"
export * from "./mini-program-message-release-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb7da9",
  null
  
)

export default component.exports